import React, { useState, useEffect } from 'react';
import { Moon, X, ArrowRight } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import { seasonalBanner } from '../mock';

const SeasonalBanner = () => {
  const { lang } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!seasonalBanner.enabled) return;
    // Respect optional display window
    const now = new Date();
    if (seasonalBanner.startDate) {
      const start = new Date(seasonalBanner.startDate + 'T00:00:00');
      if (now < start) return;
    }
    if (seasonalBanner.endDate) {
      const end = new Date(seasonalBanner.endDate + 'T23:59:59');
      if (now > end) return;
    }
    const dismissed = typeof window !== 'undefined' && localStorage.getItem('murat_banner_dismissed');
    if (dismissed !== seasonalBanner.key) setVisible(true);
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.style.setProperty('--banner-h', visible ? '40px' : '0px');
    return () => {
      document.documentElement.style.setProperty('--banner-h', '0px');
    };
  }, [visible]);

  if (!visible) return null;
  const copy = seasonalBanner[lang] || seasonalBanner.fr;

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem('murat_banner_dismissed', seasonalBanner.key);
    } catch (e) {}
  };

  const goContact = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    } else {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] text-[#0d1b36]"
      style={{
        background: 'linear-gradient(90deg, #e5bc5f 0%, #d4a94c 50%, #e5bc5f 100%)'
      }}
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <span className="hidden sm:flex items-center gap-2 text-[9px] tracking-[0.3em] uppercase font-semibold whitespace-nowrap">
            <Moon className="w-3.5 h-3.5" strokeWidth={1.75} />
            {copy.tag}
          </span>
          <span className="hidden sm:inline h-3 w-px bg-[#0d1b36]/30" />
          <p className="text-xs sm:text-sm font-medium truncate">
            {copy.message}
          </p>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          <button
            onClick={goContact}
            className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#0d1b36] text-[#f6ecd9] text-[10px] tracking-[0.2em] uppercase font-semibold hover:bg-[#1a2a4a] transition-colors whitespace-nowrap"
          >
            {copy.cta}
            <ArrowRight className="w-3 h-3" strokeWidth={2} />
          </button>
          <button
            onClick={dismiss}
            aria-label="Dismiss"
            className="w-7 h-7 rounded-full flex items-center justify-center hover:bg-[#0d1b36]/15 transition-colors"
          >
            <X className="w-3.5 h-3.5" strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeasonalBanner;
